import './styles/LockerColumnStyle.css';
import { LockerColumnTypes, LockerPosition } from '../../models/microservices';

interface LockerColumnProps {
  onSelectCompartment(position: LockerPosition): void;
  lockerColumn: LockerPosition[];
  currentCompartment: LockerPosition;
  showStatus?: boolean;
}

const LockerColumn: React.FC<LockerColumnProps> = ({
  onSelectCompartment,
  lockerColumn,
  currentCompartment,
  showStatus,
}) => {
  const getCompartmentStatus = (position: LockerPosition) => {
    if (showStatus && position.lockerPositionStatus) {
      return position.lockerPositionStatus.name;
    }
    return '';
  };
  const renderCompartmentContent = (position: LockerPosition) => {
    if (position.lockerPositionType.name === LockerColumnTypes.SCREEN) {
      return (
        <div className="locker-column-master-screen-container">
          <div className="locker-column-master-screen"></div>
        </div>
      );
    }
    return (
      <p className="locker-column-compartment-title">
        {position.row}
        {position.column}
      </p>
    );
  };
  const renderCurrentIndicator = (position: LockerPosition) => {
    if (
      position.packageCandidate &&
      position.packageCandidate === currentCompartment.packageCandidate
    ) {
      return (
        <div className="locker-column-compartment-current-indicator ">
          <div className="locker-column-compartment-current-indicator-container ">
            <p className="locker-column-compartment-indicator">
              {position.row}
              {position.column}
            </p>
          </div>
        </div>
      );
    }
    if (
      position.extraFields &&
      position.extraFields?.sid === currentCompartment.extraFields?.sid &&
      position.extraFields?.cid === currentCompartment.extraFields?.cid
    ) {
      return (
        <div className="locker-column-compartment-current-indicator ">
          <div className="locker-column-compartment-current-indicator-container ">
            <p className="locker-column-compartment-indicator">
              {position.row}
              {position.column}
            </p>
          </div>
        </div>
      );
    }
    return null;
  };
  const renderLockerCompartment = (position: LockerPosition) => {
    return (
      <>
        {renderCompartmentContent(position)}
        {renderCurrentIndicator(position)}
      </>
    );
  };
  return (
    <div className="locker-column-container">
      <div className="locker-column">
        {lockerColumn.map((position) => {
          return (
            <div
              key={position.id}
              onClick={() => {
                onSelectCompartment(position);
              }}
              className={`locker-column-compartment ${
                position.lockerPositionType.name
              } ${getCompartmentStatus(position)}`}
            >
              {renderLockerCompartment(position)}
            </div>
          );
        })}
      </div>
      <div className="locker-column-footer" />
    </div>
  );
};

export { LockerColumn };
